export default __webpack_public_path__ + "assets/models/c3d72ffc49faaaf8548b4ad118382d0e.glb";